import { useState, useCallback, useEffect } from 'react';
import { Manufacturer, ProductBase } from '@/types/product';

// Interfaz para las opciones de ordenamiento
export interface SortOption {
  value: string;
  label: string;
}

// Interfaz para las opciones de filtro
export interface FilterOption {
  value: string;
  label: string;
}

// Interfaz para el hook
export interface UseProductFiltersReturn {
  // Estados
  selectedOptions: string[];
  selectedManufacturer: Manufacturer | null;
  priceRange: [number, number] | null;
  sortBy: string | null;
  
  // Métodos
  setSelectedOptions: (options: string[]) => void;
  setSelectedManufacturer: (manufacturer: Manufacturer | null) => void;
  setPriceRange: (range: [number, number]) => void;
  setSortBy: (sort: string) => void;
  clearAllFilters: () => void;
}

export const useProductFilters = (): UseProductFiltersReturn => {
  // Estados para filtros
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedManufacturer, setSelectedManufacturer] = useState<Manufacturer | null>(null);
  const [priceRange, setPriceRange] = useState<[number, number] | null>(null);
  const [sortBy, setSortBy] = useState<string | null>(null);


  // Método para limpiar todos los filtros
  const clearAllFilters = useCallback(() => {
    setSelectedOptions([]);
    setSelectedManufacturer(null);
    setPriceRange(null);
    setSortBy(null);
  }, []);

  // Aplicar filtros cuando cambien los productos base o los filtros


  return {
    // Estados
    selectedOptions,
    selectedManufacturer,
    priceRange,
    sortBy,

    // Métodos
    setSelectedOptions,
    setSelectedManufacturer,
    setPriceRange,
    setSortBy,
    clearAllFilters,
  };
};

// Hook para opciones de ordenamiento
export const useSortOptions = () => {
  const sortOptions: SortOption[] = [
    { value: 'position', label: 'Ordenar por Posición' },
    { value: 'price_ASC', label: 'Precio: Menor a Mayor' },
    { value: 'price_DESC', label: 'Precio: Mayor a Menor' },
    { value: 'name_ASC', label: 'Nombre A-Z' },
    { value: 'newest', label: 'Más Nuevos' }
  ];

  const getCurrentSortLabel = (sortBy: string) => {
    return sortOptions.find(option => option.value === sortBy)?.label || 'Ordenar por Posición';
  };

  return {
    sortOptions,
    getCurrentSortLabel
  };
};

// Hook para opciones de filtro
export const useFilterOptions = () => {
  const filterOptions: FilterOption[] = [
    { value: 'sin-gluten', label: 'Sin gluten' },
    { value: 'bio', label: 'Bio' },
    { value: 'promotion', label: 'Promoción' },
    { value: 'sugar-free', label: 'Sugar free' }
  ];

  const getFilterLabel = (filterValue: string) => {
    return filterOptions.find(option => option.value === filterValue)?.label || filterValue;
  };

  return {
    filterOptions,
    getFilterLabel
  };
}; 